// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3vfai","buttons":"SendReceipts_buttons__YzcHZ","email":"SendReceipts_email__3NzB7","bookApptTitle":"SendReceipts_bookApptTitle__2v2ZI"};